@if (isLoading) {
  <app-spinner [message]="''" />
}

@if (!isLoading) {
  @for (item of folders; track item._id) {
    <app-list-item
      [selected]="selectedFolder?._id === item._id"
      [hasMenu]="true"
      (click)="selectFolder(item)"
    >
      <mat-icon itemIcon>folder</mat-icon>
      <span itemTitle>{{ item.name }}</span>
      <ng-container itemMenu>
        <button mat-menu-item (click)="editFolder(item, $event)">
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>
        <button mat-menu-item (click)="deleteFolder(item)">
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      </ng-container>
    </app-list-item>
  }
  @if (folders.length === 0) {
    <p class="empty-indicator">No material folders yet</p>
  }
}
